import { Height } from "@mui/icons-material";
import styled from "styled-components";

export const H2 = styled.h2(() => {
  return {
    fontWeight: 500,
    fontSize: "18px",
    textAlign: "left",
    marginBottom: "10px",
    marginTop: "20px",
  };
});
export const Title = styled.h2(() => {
  return {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    borderBottom: `solid 1px #a80000`,
    "& > h2": {
      fontWeight: 600,
      marginBottom: "10px",
      fontSize: "22px",
    },
  };
});

export const customStyles = {
  borderRadius: "50px",
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "420px",
    height: "430px",
    borderRadius: 30,
    "@media(max-width: 575px)": {
      maxWidth: "300px",
    },
    "@media(max-width: 479px)": {
      maxWidth: "270px ! important",
    },
  },
};

export const styles = {
  box: {
    textAlign: "left",
    backgroundColor: "#F3FAFC",
    borderRadius: "33px",
    height: "150px",
    padding: "0 70px",
    width: "67%",
    display: "flex",
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
  },
  error: {
    fontSize: "small",
    color: "red",
  },
  dollarSign: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    fontSize: "24px",
    borderRadius: "5px",
    textAlign: "center",
    marginTop: "25px",
    marginLeft: "5px",
  },
  inputField: {
    height: "40px",
    width: "150px",
    padding: "5px 20px 5px 20px", // Adjusted padding for the dollar sign
    fontSize: "24px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    marginTop: "25px",
    marginRight: "25px",
    position: "relative",
  },
  inputAmmount: {
    height: "30px",
    width: "150px",
    textAlign: "right",
    padding: "5px",
    fontSize: "24px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    marginTop: "25px",
    marginRight: "25px",
  },
};

export const actionButtonStyles = {
  padding: "1px 20px", // Adjust padding as needed
  backgroundColor: "#339BC8", // Button background color
  color: "#ffffff", // Button text color
  border: "none", // Remove border
  borderRadius: "30px", // Add rounded corners
  cursor: "pointer", // Show pointer cursor on hover
  transition: "background-color 0.3s ease", // Smooth hover effect
  width: "200px",
  height: "30px",
  marginTop: "20px",
  marginLeft: "100px",
  fontWeight: "",
};

export const actionButtonHoverStyles = {
  backgroundColor: "#46b8da", // Darker background color on hover
};

export const WalletButton = ({
  onClick,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  children,
}) => (
  <StyledWalletButton
    style={
      isHovered
        ? { ...actionButtonStyles, ...actionButtonHoverStyles }
        : actionButtonStyles
    }
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    onClick={onClick}
  >
    {children}
  </StyledWalletButton>
);

export const CMListsTable = styled.div((props) => ({
  fontWeight: "normal",
  fontSize: 16,
  paddingLeft: 0,
  paddingTop: 50,
  fontFamilies: props.theme.fontFamilies.Jost,
  "& .MuiDataGrid-root": {
    "& .MuiDataGrid-cell": {
      boxSizing: "none",
      borderBottom: `solid 1px #e5e5e5`,
      backgroundPosition: "bottom",
      backgroundRepeat: "no-repeat",
      backgroundSize: "unset",
      backgroundImage: "unset",
    },
    "& .MuiDataGrid-virtualScroller": {
      marginTop: "35px !important",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "normal",
      fontSize: 16,
      fontFamilies: props.theme.fontFamilies.Jost,
    },
    "& .MuiDataGrid-cellContent": {
      fontWeight: "normal",
      fontSize: 16,
      fontFamilies: props.theme.fontFamilies.Jost,
    },
  },
}));

export const TableContainer = styled.div`
  display: flex;
  margin-top: 30px;
  overflow: auto;
  justify-content: flex-start;
`;

export const StyledWalletButton = styled.button`
  @media (max-width: 767px) {
    margin-left: 40px !important;
    margin-top: 0px !important;
    width: 300px !important;
    height: 40px !important;
    padding: 10px !important;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 12px 10px;
    border-bottom: 2px solid #ddd;
    text-align: left;
    white-space: nowrap;
  }

  th {
    //background-color: #f2f2f2;
    font-weight: 500;
  }

  tbody tr:nth-child(even) {
    //background-color: #f9f9f9;
  }

  tbody tr:hover {
    background-color: #f1f1f1;
  }
`;

export const CMAuctions = styled.div((props) => ({
  marginTop: "60px",
  '@media (min-width: 2000px)': {
        height: '100%',
  },
  "& .pagination ul": {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexWrap: "wrap",
    float: "right",
  },
  "& .pagination li": {
    marginRight: "10px",
    marginBottom: "10px",
    '@media (min-width: 2000px)': {
        width: '5vh',
        height:"5vh",
        "& > a": {
          fontSize: '2vh !important',
          width: '4vh !important',
          height:"4vh !important",
          borderRadius:"15% !important"
        }
    },
  },
  "& .pagination page-num": {},

  "& .pagination .page-num": {
    padding: "4px 10px",
    cursor: "pointer",
    borderRadius: "3px",
    fontWeight: "400",
    color: "#808080",
  },
  "& .pagination .page-num:hover": {
    backgroundColor: "#808080",
    color: "#FFF",
  },
  "& .pagination .active": {
    backgroundColor: "#808080",
    color: "#FFF",
    '@media (min-width: 2000px)': {
        width: '10vh',
        height:"4vh",
    },
  },
}));

export const TransactionContend = styled.div((props) => ({
  width: "auto",
  display: "flex",
  '& .table-transaction-content': {
    display: "flex",
    flexWrap: 'wrap',
    marginTop: '40px',
    flexDirection: "column",
  },
  '& .transaction-row': {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "20px"
  },
  '& .transaction-button': {
    marginLeft: "12px",
    marginTop: "3px",
    padding: '10px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: "40px",
    '& > img': {
      width: '15px',
      height: '15px',
      marginTop: '-10px',
      filter: 'invert(46%) sepia(83%) saturate(449%) hue-rotate(86deg) brightness(92%) contrast(89%)',
    },
  },

}));
